
import CryptoJs from 'crypto-js'
//var base64 = require('base64.js');
// 密钥 16 位
var key = 'protectumbrella.';
// key 和 iv 可以一致
key = CryptoJs.enc.Utf8.parse(key);
//加密
export function encrypted(param) {
  var encryptContent = CryptoJs.AES.encrypt(param, key, {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.Pkcs7
  });
  encryptContent = encryptContent.toString();
  //encrypted = base64.encode(encrypted);
  return encryptContent;
}
//解密
export function decrypted(param) {
  var decryptContent = CryptoJs.AES.decrypt(param, key, {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.Pkcs7
  });
  decryptContent = CryptoJs.enc.Utf8.stringify(decryptContent);
  return decryptContent;
}



// WEBPACK FOOTER //
// ./src/utils/encrypt.js